import { render } from "./HomeTopCategories.vue?vue&type=template&id=24bf98a2&scoped=true"
import script from "./HomeTopCategories.vue?vue&type=script&lang=js"
export * from "./HomeTopCategories.vue?vue&type=script&lang=js"

import "./HomeTopCategories.vue?vue&type=style&index=0&id=24bf98a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24bf98a2"]])

export default __exports__